// src/components/Reports/LedgerSearch.tsx
import React, { JSX, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, TextField, Button } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useLedger } from "../../../hooks/useLedger";
import LedgerTable from "./LedgerTable";

export const LedgerSearch = () => {
	const navigate = useNavigate();
	const { ledgerEntries, loading, fetchLedgerData } = useLedger();
	const currentDate = new Date().toLocaleDateString("en-CA");
	const [startDate, setStartDate] = useState<string>(currentDate);
	const [endDate, setEndDate] = useState<string>(currentDate);

	useEffect(() => {
		fetchLedgerData(startDate, endDate);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSearch = () => {
		if (!startDate || !endDate) {
			alert("Please select both start and end dates.");
			return;
		}
		if (startDate > endDate) {
			alert("Start date cannot be after end date.");
			return;
		}
		fetchLedgerData(startDate, endDate);
	};

	const renderSearch = (): JSX.Element => {
		return (
			<Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, mt: 0 }}>
				<Typography variant="h5" gutterBottom>
					Search Ledger by Date Range
				</Typography>
				<div
					style={{
						display: "flex",
						gap: "1rem",
						marginBottom: "1rem",
						alignItems: "center",
						flexWrap: "nowrap"
					}}
				>
					<TextField
						label="Start Date"
						type="date"
						value={startDate}
						onChange={(e) => setStartDate(e.target.value)}
						InputLabelProps={{ shrink: true }}
						size="small"
						fullWidth={true}
					/>
					<TextField
						label="End Date"
						type="date"
						value={endDate}
						onChange={(e) => setEndDate(e.target.value)}
						InputLabelProps={{ shrink: true }}
						fullWidth={true}
						size="small"
					/>
					<Button
						variant="contained"
						size="medium"
						onClick={handleSearch}
					>
						Search
					</Button>
				</div>
			</Paper>
		);
	};

	if (loading) return <p>Searching ledger...</p>;

	return (
		<Paper elevation={3} sx={{ p: { xs: 2, md: 3 }, mt: 0 }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					mb: 2,
					gap: 1
				}}
			>
				<Typography variant="h5">Ledger Search</Typography>
				<Button
					variant="contained"
					startIcon={<HomeIcon />}
					onClick={() => navigate("/")}
				>
					Go to Home
				</Button>
			</Box>
			{renderSearch()}
			<LedgerTable ledgerEntries={ledgerEntries} />
		</Paper>
	);
};
